import { useSelector } from 'react-redux';
import { ActionType, CardCombinedType, FormType } from '../../types/chat.types';
import { globalCards } from '../../utils/global.card';
import { AppDispatch, RootState } from '../../redux/store';
import { useDispatch } from 'react-redux';

type CardProps = {
  card: any;
  handleCardClick: (card: CardCombinedType) => void;
  handleSetResponse: (response: any) => void;
  handelUserInput: (input: string) => void;
};

function AdaptiveCard(props: CardProps) {
  // eslint-disable-next-line
  const { card, handleCardClick, handleSetResponse, handelUserInput } = props;
  const authState = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();

  const handleClick = (action: ActionType | FormType) => {
    switch (action.actionType) {
      case 'send-chat': {
        if ('title' in action) {
          handelUserInput(action.title as string);
        }
        return;
      }
      case 'display-data-card':
        handleCardClick({ type: 'display-data-card' });
        return;
      case 'new-user':
        handleCardClick({
          type: 'adaptive-card',
          msg: 'How may I help you today?',
          actions: [
            { title: 'Start Free Trial', actionType: 'startFreeTrial' },
            { title: 'Contact Sales', actionType: 'contactSale' },
            { title: 'Check Pricing', actionType: 'check-pricing' },
            {
              title: 'File 1099 Form',
              actionType: 'filling-1099-form',
            },
            { title: 'Contact Support', actionType: 'contact-support' },
          ],
        });
        return;
      case 'existing-user':
        handleCardClick({
          type: 'adaptive-card',
          msg: 'How may I help you today?',
          actions: [
            { title: 'Start Free Trial', actionType: 'startFreeTrial' },
            { title: 'Contact Sales', actionType: 'contactSale' },
            { title: 'Check Pricing', actionType: 'check-pricing' },
            {
              title: 'File 1099 Form',
              actionType: 'filling-1099-form',
            },
            { title: 'Contact Support', actionType: 'contact-support' },
            { title: 'Ask me anything', actionType: 'ask-me-anything' },
          ],
        });
        return;
      case 'check-pricing':
        handleCardClick({
          type: 'adaptive-card',
          msg: 'Our pricing plans are designed to add value to your experience. We believe in transparency and providing you with the best solutions for your needs.',
          actions: [
            {
              title: 'Pricing Calculator',
              actionType: 'pricingCalculatorCard',
            },
            { title: 'Compare Plans', actionType: 'compare-plans' },
            { title: 'Contact Sales', actionType: 'contactSale' },
            { title: 'Pricing Guide', actionType: 'pricing-guide' },
          ],
        });
        return;
      case 'contact-support': {
        const contactSupport: FormType = {
          type: 'adaptive-from',
          label: 'Great! Could you please login to your account',
          actionType: 'customerSupportStep2',
          formItem: [
            {
              name: 'Email Id',
              placeHolder: 'Email ID',
              type: 'Email',
              DataType: 'string',
            },
            {
              name: 'Password',
              placeHolder: 'Password',
              type: 'string',
              DataType: 'string',
            },
          ],
        };
        handleCardClick(contactSupport);
        return;
      }
      case 'login-with-appKey': {
        const customizeAndCalculate: FormType = {
          type: 'adaptive-from',
          label: 'Great! Could you please login to your account',
          actionType: 'customizeAndCalculate',
          formItem: [
            {
              name: 'Email Id',
              placeHolder: 'Email ID',
              type: 'Email',
              DataType: 'string',
            },
            {
              name: 'Password',
              placeHolder: 'Password',
              type: 'string',
              DataType: 'string',
            },
            {
              name: 'AppKey',
              placeHolder: 'App Key',
              type: 'string',
              DataType: 'string',
            },
          ],
        };
        handleCardClick(customizeAndCalculate);
        return;
      }
      case 'existingTax1099User': {
        dispatch({ type: 'CLEAR_ALL_FORM_DATA', payload: {} });
        handleCardClick(globalCards['existingTax1099User']);
        return;
      }
      case 'startApiEnable': {
        handleCardClick(globalCards['startApiEnable']);
        return;
      }
      case 'startSelectForm': {
        handleCardClick(globalCards['startSelectForm']);
        return;
      }
      case 'customerSupportStep2': {
        handleCardClick(globalCards['customerSupportStep2']);
        return;
      }
      case 'customizeAndCalculate': {
        handleCardClick(globalCards['customizeAndCalculate']);
        return;
      }
      case 'customizeAndCalculateStep3': {
        handleCardClick(globalCards['customizeAndCalculateStep3']);
        return;
      }
      case 'custAndCaluCheckEstimatedPricing': {
        handleCardClick(globalCards['custAndCaluCheckEstimatedPricing']);
        return;
      }
      case 'calendlyWidget': {
        handleCardClick(globalCards['calendlyWidget']);
        return;
      }
      case 'filling-1099-form': {
        handleCardClick(globalCards['filling1099Form']);
        return;
      }
      case 'filling1099Form': {
        const cardType = authState.auth
          ? 'existingTax1099User'
          : 'filling1099Form';
        handleCardClick(globalCards[cardType]);
        return;
      }
      case 'form1099NEC': {
        handleSetResponse({ type: 'SET_FORMTYPE', data: 'NEC' });
        handleCardClick(globalCards['NoOfFormSelectionCard']);
        return;
      }
      case 'form1099MISC': {
        handleSetResponse({ type: 'SET_FORMTYPE', data: 'MISC' });
        handleCardClick(globalCards['NoOfFormSelectionCard']);
        return;
      }
      case 'USPS-beforeSubmittingToIRSPreviewForm': {
        handleSetResponse({
          type: 'SET_ITEM_FORM',
          data: { delivery: 'USPS' },
        });

        handleCardClick(globalCards['beforeSubmittingToIRSPreviewForm']);
        return;
      }
      case 'IRS-e-Delivery-beforeSubmittingToIRSPreviewForm': {
        handleSetResponse({
          type: 'SET_ITEM_FORM',
          data: { delivery: 'E-Delivery' },
        });
        handleCardClick(globalCards['beforeSubmittingToIRSPreviewForm']);
        return;
      }
      case 'last-3-submissions': {
        handleCardClick(globalCards['lastSubmissions']);
        return;
      }
      case 'compare-plans': {
        window.open('https://www.tax1099.com/tax-1099-efile-pricing', '_blank');
        return;
      }
      case 'refer-earn': {
        window.open('https://refer.tax1099.com/aichat', '_blank');
        return;
      }
      case 'pricing-guide': {
        window.open('https://www.tax1099.com/tax-1099-efile-pricing', '_blank');
        return;
      }
      default: {
        if (
          action?.actionType !== '' &&
          Object.prototype.hasOwnProperty.call(
            globalCards,
            action?.actionType as string,
          )
        ) {
          handleCardClick(globalCards[action?.actionType as string]);
          return;
        }
        handleCardClick(globalCards['thankYouCard']);
        return;
      }
    }
    // if (action.actionType === 'new-user') {
    //   handleCardClick({ type: 'adaptive-card', msg: 'How may I help you today?', actions: [{ title: 'Start Free Trial', actionType: 'new-user' }, { title: 'Contact Sales', actionType: 'existing-user' }, { title: 'Check Pricing', actionType: 'new-user' }, { title: 'File 1099 Form', actionType: 'existing-user' }, { title: 'Contact Support', actionType: 'new-user' }, { title: 'Ask me anything', actionType: 'existing-user' }] })
    // }
  };
  return (
    <div className="m-1">
      {/* <div className="mb-4 mx-3 text-left">{card.msg}</div> */}
      <div dangerouslySetInnerHTML={{ __html: card.msg }} />
      <div className="flex flex-wrap justify-between align-center gap-4 mx-4 mt-2">
        {card &&
          card.actions &&
          card.actions.length > 0 &&
          card.actions.map((action: ActionType) => {
            return (
              <button
                key={`action-${action.title}`}
                onClick={() => handleClick(action)}
                className="bg-white w-full enabled:hover:bg-primary enabled:hover:text-white text-primary font-semibold py-2 px-4 border border-primary rounded"
                // className="ml-2 p-2 w-full rounded-full bg-primary text-white hover:bg-blue-900 focus:outline-none"
              >
                {action.title}
              </button>
            );
          })}
      </div>
    </div>
  );
}

export default AdaptiveCard;
